document.addEventListener('DOMContentLoaded', function() {
    const reviewStars = document.querySelector('.jdgm-prev-badge__stars');
    if (reviewStars) {
        reviewStars.addEventListener('click', function(event) {
            event.preventDefault();
            const testimonialsWrapper = document.querySelector('.jdgm-testimonials-carousel');
            if (testimonialsWrapper) {
                testimonialsWrapper.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    }

    function parseMoneyValue(text) {
        const raw = (text || '').replace(/\s+/g, ' ').trim();
        const match = raw.match(/^([^0-9-]*)(-?[0-9.,]+)(.*)$/);
        if (!match) return null;

        const prefix = match[1] || '';
        const numberToken = match[2];
        const suffix = match[3] || '';

        const lastDot = numberToken.lastIndexOf('.');
        const lastComma = numberToken.lastIndexOf(',');
        const hasDot = lastDot !== -1;
        const hasComma = lastComma !== -1;

        let decimalSeparator = '.';
        if (hasDot && hasComma) {
            decimalSeparator = lastDot > lastComma ? '.' : ',';
        } else if (hasComma) {
            decimalSeparator = ',';
        }

        const thousandsSeparator = decimalSeparator === '.' ? ',' : '.';
        let normalized = numberToken;
        const thousandsRegex = new RegExp('\\' + thousandsSeparator, 'g');
        normalized = normalized.replace(thousandsRegex, '');
        if (decimalSeparator === ',') {
            normalized = normalized.replace(',', '.');
        }

        const value = Number(normalized);
        if (Number.isNaN(value)) return null;

        const decimals = numberToken.includes(decimalSeparator)
            ? numberToken.split(decimalSeparator)[1].length
            : 0;

        return { prefix, suffix, value, decimals, decimalSeparator, thousandsSeparator };
    }

    function formatMoneyLikeTemplate(parts, value) {
        const decimals = parts.decimals;
        const decimalSeparator = parts.decimalSeparator;
        const thousandsSeparator = parts.thousandsSeparator;

        let [intPart, fracPart] = value.toFixed(decimals).split('.');
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        const numberText = decimals > 0 ? intPart + decimalSeparator + fracPart : intPart;
        return parts.prefix + numberText + parts.suffix;
    }

    function formatMoneyFromCents(cents) {
        const format = window.wetheme && window.wetheme.moneyFormat
            ? window.wetheme.moneyFormat
            : '${{amount}}';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        function formatWithDelimiters(value, precision, thousands, decimal) {
            const number = (Number(value) / 100).toFixed(precision);
            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            const centsPart = parts[1] ? decimal + parts[1] : '';
            return dollars + centsPart;
        }

        const match = format.match(placeholderRegex);
        if (!match) return formatMoneyLikeTemplate({ decimals: 2, decimalSeparator: '.', thousandsSeparator: ',', prefix: '$', suffix: '' }, Number(cents) / 100);

        let value = '';
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2, ',', '.');
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ', ',');
                break;
            default:
                value = formatWithDelimiters(cents, 2, ',', '.');
        }

        return format.replace(placeholderRegex, value);
    }

    function getLoopAppProductId() {
        const widgetContainer = document.querySelector('[id^="loop-widget-container-id-"]');
        if (widgetContainer) {
            return widgetContainer.id.replace('loop-widget-container-id-', '');
        }

        if (window.LOOP_WIDGET) {
            const productIds = Object.keys(window.LOOP_WIDGET);
            if (productIds.length) return productIds[0];
        }

        const productForm = document.querySelector('form[data-loop-product-id]');
        return productForm ? productForm.getAttribute('data-loop-product-id') : null;
    }

    function updateLoopAppWidgetPrices(variant) {
        if (!variant || !variant.id) return;

        const productId = getLoopAppProductId();
        if (!productId) return;

        const productIdNumber = Number(productId);
        const variantIdNumber = Number(variant.id);

        if (
            window.LoopSubscriptions &&
            typeof window.LoopSubscriptions.handleLoopWidgetVariantIdChange === 'function'
        ) {
            window.LoopSubscriptions.handleLoopWidgetVariantIdChange(productIdNumber, variantIdNumber);
        }

        const appWidget = document.getElementById('loop-widget-container-id-' + productId);
        if (!appWidget) return;

        const oneTimePrice = appWidget.querySelector('#loop-widget-purchase-option-price-onetime-' + productId);
        if (oneTimePrice && variant.price != null) {
            oneTimePrice.textContent = formatMoneyFromCents(variant.price);
        }

        const sellingPlanAllocations = Array.isArray(variant.selling_plan_allocations)
            ? variant.selling_plan_allocations
            : [];
        const allocationsByGroup = sellingPlanAllocations.reduce(function(groups, allocation) {
            if (!allocation || !allocation.selling_plan_group_id || groups[allocation.selling_plan_group_id]) return groups;
            groups[allocation.selling_plan_group_id] = allocation;
            return groups;
        }, {});

        Object.keys(allocationsByGroup).forEach(function(groupId) {
            const allocation = allocationsByGroup[groupId];
            const subscriptionOption = appWidget.querySelector(
                '[data-loop-widget-selling-plan-group][data-selling-plan-group-id="' + groupId + '"]'
            );
            if (!subscriptionOption) return;

            const subscriptionPrice = subscriptionOption.querySelector('#loop-widget-purchase-option-price-id-' + groupId);
            const compareAtPrice = subscriptionOption.querySelector('.loop-w-btn-group-purchase-option-compare-at-price');

            if (subscriptionPrice && allocation.price != null) {
                subscriptionPrice.textContent = formatMoneyFromCents(allocation.price);
            }

            if (compareAtPrice) {
                const compareCents = allocation.compare_at_price || variant.price;
                compareAtPrice.textContent = formatMoneyFromCents(compareCents);
                compareAtPrice.classList.toggle('loop-display-none', !compareCents || compareCents <= allocation.price);
            }
        });
    }

    function scheduleLoopAppWidgetVariantSync(variant) {
        updateLoopAppWidgetPrices(variant);
        setTimeout(function() { updateLoopAppWidgetPrices(variant); }, 100);
        setTimeout(function() { updateLoopAppWidgetPrices(variant); }, 350);
    }

    function updateSubscribePriceInCartRecommendations(scope) {
        const root = scope || document;
        const widgets = root.querySelectorAll(
            '[data-cart-drawer-recommendations] .loop-subscription-container[data-loop-on-product-card="true"]'
        );

        widgets.forEach(function(widget) {
            const oneTimeAmountEl = widget.querySelector('.loop-one-time-purchase-option-price-amount');
            const discountPctEl = widget.querySelector('.loop-subscription-group .loop-discount-badge__pct');
            const subscribeAmountEl = widget.querySelector('.loop-subscription-group .loop-subscription-group-price-amount');
            const subscribePriceContainer = widget.querySelector('.loop-subscription-group .loop-subscription-group-price-container');

            if (!oneTimeAmountEl || !discountPctEl || !subscribeAmountEl || !subscribePriceContainer) return;

            const baseMoney = parseMoneyValue(oneTimeAmountEl.textContent);
            const pct = Number((discountPctEl.textContent || '').replace(/[^0-9.]/g, ''));
            if (!baseMoney || Number.isNaN(pct)) return;

            const discountedValue = baseMoney.value * (1 - pct / 100);
            subscribeAmountEl.textContent = formatMoneyLikeTemplate(baseMoney, discountedValue);
            subscribePriceContainer.style.display = 'block';
            subscribePriceContainer.style.visibility = 'visible';
        });
    }

    updateSubscribePriceInCartRecommendations(document);

    if (window.eventBus && typeof window.eventBus.on === 'function') {
        window.eventBus.on('variant:updated', function(context) {
            scheduleLoopAppWidgetVariantSync(context && context.variant);
        });
    }

    let cartDrawerUpdateTimer = null;
    const scheduleCartDrawerPriceRefresh = function(scope) {
        if (cartDrawerUpdateTimer) {
            clearTimeout(cartDrawerUpdateTimer);
        }
        cartDrawerUpdateTimer = setTimeout(function() {
            updateSubscribePriceInCartRecommendations(scope || document);
        }, 60);
    };

    document.addEventListener('change', function(event) {
        if (
            event.target &&
            (
                event.target.matches('input[name="loop_purchase_option"]') ||
                event.target.matches('.loop-selling-plan-selector')
            )
        ) {
            scheduleCartDrawerPriceRefresh(document);
        }
    });

    function ensureSubscriptionPlanOnSubmit(event) {
        const form = event.target;
        if (!form || form.tagName !== 'FORM') return;
        if (!form.closest('[data-cart-drawer-recommendations]')) return;

        const loopContainer = form.querySelector('.loop-subscription-container[data-loop-on-product-card="true"]');
        if (!loopContainer) return;

        const selectedOption = loopContainer.querySelector('input[name="loop_purchase_option"]:checked');
        if (!selectedOption) return;

        let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
        if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            form.appendChild(sellingPlanInput);
        }

        const isSubscription = selectedOption.classList.contains('loop-subscription-group-radio');
        if (!isSubscription) {
            sellingPlanInput.value = '';
            return;
        }

        const subscriptionGroup = selectedOption.closest('.loop-subscription-group');
        const planSelect = subscriptionGroup
            ? subscriptionGroup.querySelector('.loop-selling-plan-selector')
            : null;

        if (planSelect && planSelect.value) {
            sellingPlanInput.value = String(planSelect.value);
        }

        const variantId = selectedOption.getAttribute('data-variant-id');
        if (variantId) {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
                variantInput.value = String(variantId);
                variantInput.setAttribute('value', String(variantId));
            }
        }
    }

    document.addEventListener('submit', ensureSubscriptionPlanOnSubmit, true);

    const cartDrawerObserver = new MutationObserver(function(mutations) {
        for (let i = 0; i < mutations.length; i += 1) {
            const mutation = mutations[i];
            if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
            scheduleCartDrawerPriceRefresh(document);
            break;
        }
    });

    cartDrawerObserver.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', function() {
    /*
      GOVX ID: the drawer rebuilds its footer on every cart update, so the tag
      placed in snippets/cart-drawer.liquid comes back empty. The app only fills
      tags in on its own initial scan and never watches the DOM, so it has to be
      asked again. See GOVX-ID-BUTTON.md
    */
    const govxDrawerFooter = document.querySelector('cart-drawer [data-cart-dynamic-content="cart-footer"]');
    if (!govxDrawerFooter) return;

    function refillGovxDrawerButton() {
        const tag = govxDrawerFooter.querySelector('[data-govx-id]');
        /* Only when empty — refresh() mutates the subtree we're observing */
        if (tag && tag.children.length === 0 && window.GovXIdApi) {
            window.GovXIdApi.refresh();
        }
    }

    new MutationObserver(refillGovxDrawerButton).observe(govxDrawerFooter, { childList: true, subtree: true });
});
